import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemePickerDialogComponent } from '@core/theme/theme-picker-dialog.component';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule],
  template: `
    <button mat-icon-button class="primary-icon" (click)="openThemePicker()" matTooltip="Theme">
      <mat-icon>palette</mat-icon>
    </button>
  `,
})
export class ThemeToggleComponent {
  #dialog = inject(MatDialog);

  openThemePicker() {
    this.#dialog.open(ThemePickerDialogComponent);
  }
}
